import React from 'react';
import styled from 'styled-components';
import { ArrowRight } from 'lucide-react';

const CTAButton = ({ text, onClick, type = 'primary', className = '' }) => {
    return (
        <BtnWrapper type={type} className={className}>
            <button className="btn-12" onClick={onClick}>
                <span>
                    {text}
                    <ArrowRight size={18} className="arrow" />
                </span>
            </button>
        </BtnWrapper>
    );
};

const slideBg = props => 
  props.type === 'white' ? '#2563eb' : 
  props.type === 'outline-dark' ? '#01014c' : 
  '#fff';

const BtnWrapper = styled.div`
  display: inline-block;
  .btn-12,
  .btn-12 *,
  .btn-12 :after,
  .btn-12 :before,
  .btn-12:after,
  .btn-12:before {
    border: 0 solid;
    box-sizing: border-box;
  }

  .btn-12 {
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: button;
    background-color: ${props => 
      props.type === 'secondary' ? '#01014c' : 
      props.type === 'white' ? '#fff' : 
      (props.type === 'outline-light' || props.type === 'outline-dark') ? 'transparent' : 
      '#2563eb'
    };
    background-image: none;
    color: ${props => 
      props.type === 'white' ? '#2563eb' : 
      props.type === 'outline-dark' ? '#01014c' : 
      '#fff'
    };
    cursor: pointer;
    font-family: 'Syne', sans-serif;
    font-size: 13px;
    font-weight: 700;
    line-height: 1.5;
    margin: 0;
    -webkit-mask-image: -webkit-radial-gradient(${props => 
      props.type === 'secondary' || props.type === 'outline-dark' ? '#01014c' : 
      props.type === 'outline-light' ? '#fff' : 
      '#2563eb'
    }, #fff);
    padding: 0;
    text-transform: uppercase;
    border-radius: 12px;
    overflow: hidden;
    padding: 0.9rem 2.2rem;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    border: 2px solid ${props => 
      (props.type === 'secondary' || props.type === 'outline-dark') ? '#01014c' : 
      props.type === 'outline-light' ? 'rgba(255,255,255,0.2)' : 
      props.type === 'white' ? '#fff' : 
      '#2563eb'
    };
    box-shadow: 0 10px 20px -5px ${props => 
      props.type === 'secondary' ? 'rgba(1,1,76,0.2)' : 
      props.type === 'outline-light' || props.type === 'outline-dark' ? 'none' : 
      'rgba(37,99,235,0.3)'
    };
  }

  .btn-12:hover {
    color: ${props => 
      props.type === 'primary' ? '#2563eb' : 
      props.type === 'secondary' ? '#01014c' : 
      props.type === 'white' ? '#fff' : 
      props.type === 'outline-light' ? '#2563eb' : 
      props.type === 'outline-dark' ? '#fff' : 
      '#2563eb'
    };
    background-color: transparent;
    border-color: ${props => 
      props.type === 'primary' ? '#2563eb' : 
      props.type === 'secondary' ? '#01014c' : 
      props.type === 'white' ? '#2563eb' : 
      props.type === 'outline-light' ? 'rgba(255,255,255,0.5)' : 
      props.type === 'outline-dark' ? '#01014c' : 
      '#2563eb'
    };
    box-shadow: 0 15px 25px -5px ${props => 
      props.type === 'secondary' ? 'rgba(1,1,76,0.3)' : 
      props.type === 'outline-light' ? 'none' : 
      props.type === 'outline-dark' ? 'rgba(1,1,76,0.2)' : 
      'rgba(37,99,235,0.4)'
    };
  }

  .btn-12 span {
    display: flex;
    align-items: center;
    gap: 8px;
    z-index: 2;
  }

  .btn-12 span .arrow {
    transition: transform 0.3s ease;
  }

  .btn-12:hover span .arrow {
    transform: translateX(4px);
  }

  .btn-12:after,
  .btn-12:before {
    background: linear-gradient(
      90deg,
      ${slideBg} 25%,
      transparent 0,
      transparent 50%,
      ${slideBg} 0,
      ${slideBg} 75%,
      transparent 0
    );
    content: "";
    inset: 0;
    position: absolute;
    transform: translateY(var(--progress, 105%));
    transition: transform 0.25s ease;
    z-index: 1;
  }

  .btn-12:after {
    --progress: -105%;
    background: linear-gradient(
      90deg,
      transparent 0,
      transparent 25%,
      ${slideBg} 0,
      ${slideBg} 50%,
      transparent 0,
      transparent 75%,
      ${slideBg} 0
    );
    z-index: 1;
  }

  .btn-12:hover:after,
  .btn-12:hover:before {
    --progress: 0;
  }
`;

export default CTAButton;
